/* eslint-disable @typescript-eslint/no-unused-vars */
import { ConfiguredProductListItem } from '../list/ListTypes'
import { findInterfaceByItemNo, findMechByItemNo, findSkinByItemNo } from '../products/productUtils'
import { logErrorDebug } from '../debug/debugLogging'
import { ProductDataShape } from '../ProductDataShape'

/**
 * filters out products that aren't in the product data
 * @param configuredProducts
 * @param productData
 */
export function removeListItemsIfNotInProductData(configuredProducts: readonly ConfiguredProductListItem[], productData: ProductDataShape): readonly ConfiguredProductListItem[] {
  return configuredProducts.filter(it => {
    try {
      const { configuredProduct } = it

      // if any of these lookups fail to find the product, an error will be thrown, and the product will be removed
      const skin = findSkinByItemNo(configuredProduct.skinItemNo, productData.skinGridProducts)
      const interfaces = configuredProduct.interfaces.forEach(item => {
        const interfaceProduct = findInterfaceByItemNo(item.interfaceItemNo, productData.interfaces)
        const mech = findMechByItemNo(item.mechItemNo, productData.mechs)
      })

      return true
    } catch (err) {
      logErrorDebug('error loading product, not found in product data; removing', it, err)
      return false
    }
  })
}
